import type { CheckoutConfig } from '#types/config/components/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  helpUrl: '/contact-us',
  logoVariant: 'full',
  brandClasses: {}
} satisfies RecursivePartial<CheckoutConfig['footer']>
